<div class="list-header">
    <ng-content></ng-content>
    <div class="list-header__status" *ngIf="showCounter">
        <span *ngIf="text">{{ text }}:&nbsp;</span>
        <span>{{ itemsCount }}</span>
    </div>
</div>
